<script>
	import {fade} from "svelte/transition";
	import {theme} from "../stores/theme";
	import {loginErrors} from "../stores/errors";
</script>

<div class="min-h-screen flex flex-col justify-start items-center px-12 bg-neutral-400">
	{#if $loginErrors.message}
		<div in:fade={{duration: 150}} class="absolute w-full sm:max-w-lg mt-4 bg-red-600 text-white text-center px-4 py-2 rounded-lg">
			{@html $loginErrors.message}
		</div>
	{/if}

    <div class="w-full mt-40 sm:max-w-lg shadow-xl overflow-hidden rounded-lg bg-theme-background">
        <div class="p-8">
			{#if $theme.customerLogo}
				<div class="flex justify-center">
					<img class="w-40 mb-4" src={$theme.customerLogo} alt="Logo">
				</div>
			{/if}
            <slot/>
        </div>
    </div>
</div>
